import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, EMPTY } from 'rxjs';
import { catchError, finalize, map, mergeMap } from 'rxjs/operators';
import { AppState } from '../reducers';
import { loadProductPrice, loadProductPriceFailure, loadProductPriceSuccess } from './product-price.actions';
import { ProductPriceApiService } from './product-price.api.service';

@Injectable()
export class ProductPriceEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private api: ProductPriceApiService,
  ) {}

  // Dedupe concurrent requests per key
  private pending: Record<string, boolean> = {};

  private _toErrorMessage(error: any): string {
    if (!error) {
      return 'Unknown error';
    }

    if (typeof error === 'string') {
      return error;
    }

    if (error?.error?.message) {
      return String(error.error.message);
    }

    if (error?.message) {
      return String(error.message);
    }

    return 'Request failed';
  }

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProductPrice),
      mergeMap((action) => {
        const key = action.key;
        if (this.pending[key]) {
          return EMPTY;
        }
        this.pending[key] = true;
        return this.api.getProductPrice(action.params).pipe(
          map((data) => loadProductPriceSuccess({ key, data })),
          catchError((error) => of(loadProductPriceFailure({ key, error: this._toErrorMessage(error) }))),
          finalize(() => {
            delete this.pending[key];
          }),
        );
      }),
    ),
  );
}
